import React from "react";
import { Card, Button } from "@shopify/polaris";
import { resetTransients } from "../../services/wpApi";
import useToast from "../../hooks/useToast";

export default function ResetTransients() {
  const setToast = useToast();
  return (
    <Card.Section title="Refresh Cache">
      <p className="ri-mb-3">
        For performance, Real ID will cache some data like your current
        settings.
      </p>
      <p className="ri-mb-4">
        This cache will automatically update on certain actions, but if you
        notice some settings not updating, clearing the cache might help.
      </p>
      <Button
        onClick={() =>
          resetTransients()
            .then(() => setToast("Cache cleared"))
            .catch((e) => setToast("Failed to clear cache"))
        }
      >
        Reset Cache
      </Button>
    </Card.Section>
  );
}
